<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button
        v-b-modal="'pdf-comprobante-'+idMovimiento"
        variant="info"
        size="sm"
        v-on:click="descargarPdf"
    >
      <font-awesome-icon icon="file"/>
    </b-button>
    <b-modal
        ok-title="Aceptar"
        cancel-title="Cerrar"
        size="xl"
        :id="'pdf-comprobante-'+idMovimiento" title="Comprobante del movimiento">
      <iframe :src="pdf" v-if="pdf!= null && movimientoService.loading === false" style="height: 500px; width: 100%"></iframe>
      <div v-else class="text-center">
        <h3>Cargando por favor espere...</h3>
        <b-spinner variant="primary" label="cargando"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";

export default {
  name: "MostrarComprobanteMovimiento",
  props: {
    idMovimiento: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    movimientoService: new MovimientoService(),
    pdf: null
  }),
  methods: {
    descargarPdf() {
      this.movimientoService.getPdfMovimiento(this.idMovimiento).then(pdf => {
        this.pdf = pdf;
        this.descargar("COMP_"  + new Date(), pdf.data);
      })
    },

    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {
        type: "application/pdf"
      });

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      link.click();
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>